import { Injectable, Inject } from '@angular/core';
import { ReplaySubject, Observable } from 'rxjs';
import { DOCUMENT } from '@angular/common';

@Injectable()
export class LazyLoadScriptService {
    loadedLibraries: { [url: string]: ReplaySubject<void> } = {};

    constructor(@Inject(DOCUMENT) private readonly document: Document) { }

    loadScript(url: string,appname:string): Observable<void> {

        if (this.loadedLibraries[url]) {
            return this.loadedLibraries[url].asObservable();
        }

        this.loadedLibraries[url] = new ReplaySubject();

        const jselement = this.document.createElement('script');
        jselement.type = 'text/javascript';
        jselement.src = url;
        jselement.id = appname;
        
        jselement.onload = () => {
            this.loadedLibraries[url].next();
            this.loadedLibraries[url].complete();
        };
        var headEL = this.document.getElementsByTagName("head")[0];
        headEL.appendChild(jselement);
        
        return this.loadedLibraries[url].asObservable();
    }
}